import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { RouterClient } from '@tanstack/react-router/ssr/client';

import { createAppRouter } from './router';
import { initAnalytics } from './lib/analytics';
import './styles.css';

/**
 * 서버가 그린 문서를 그대로 이어받는다 (hydration, docs/SSR.md).
 *
 * 서버는 같은 라우트 트리를 HTML 로 그리고, 라우터 상태와 Query 캐시를 함께
 * 실어 보낸다 (entry-server.tsx). RouterClient 가 그 상태를 복원한 뒤 React 가
 * 기존 DOM 에 이벤트만 붙인다 — 마크업을 지우고 다시 그리지 않는다.
 * 로그인 화면(ssr: false 라우트)은 hydration 뒤 브라우저에서 그린다.
 */
const router = createAppRouter();

// GA4 — 측정 ID 가 있을 때만. page_view 는 __root 의 usePageViews.
initAnalytics();

hydrateRoot(
  document,
  <StrictMode>
    <RouterClient router={router} />
  </StrictMode>,
);
